module.exports = __webpack_public_path__ + "img/tn3.be6a7ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/TamiNadu/tn3.jpg
// module id = 1735
// module chunks = 1